import script from "./PlatformBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformBanner.vue?vue&type=script&setup=true&lang=js"

import "./PlatformBanner.vue?vue&type=style&index=0&id=488bcec6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-488bcec6"]])

export default __exports__